import { MessageToast } from '@lotta/self-service/lottery-fe/feature-toast';
import { Outlet } from 'react-router-dom';
import { Header } from '../layout-header/Header';
import styles from './Layout.module.scss';
/* eslint-disable-next-line */
export type LayoutWrapperProps = {};

export const Layout: React.FC<LayoutWrapperProps> = () => {
  return (
    <>
      <MessageToast />
      <Header />
      <div className={styles['wrapper']}>
        <Outlet />
      </div>
    </>
  );
};
